export const MAX_CHALLENGES = 7
export const ALERT_TIME_MS = 2000
export const REVEAL_TIME_MS = 350
export const WELCOME_INFO_MODAL_MS = 350
export const DISCOURAGE_INAPP_BROWSERS = true
export const ENABLE_MIGRATE_STATS = true
export const BLOWFISH_KEY = '?xbU;L:1J`3k]$d+A$FGlr7JbtqyRC'
export const BLOWFISH_IV = '#4/WJ55X'
